import { ref, computed } from 'vue';

import { useCalculationsStore } from '../store/calculations';
import { useClientsStore } from '../store/clients';

export function useSearchCalculations(calculatorId: number) {
  const calculationsStore = useCalculationsStore();
  const clientsStore = useClientsStore();

  const search = ref('');

  const searchedCalculations = computed(() => {
    const all = calculationsStore.data || [];

    const childrenByParentId = new Map<number, typeof all>();

    all.forEach((calculation) => {
      const parentId = (calculation as any).parent_id;

      if (parentId == null || calculation.id === null) return;

      const list = childrenByParentId.get(parentId) || [];
      list.push(calculation);
      childrenByParentId.set(parentId, list);
    });

    return all
      .filter((calculation) => calculation.calculator_id === calculatorId)
      .filter((calculation) => (calculation as any).parent_id == null)
      .filter((calculation) => {
        return calculation.name.toLocaleLowerCase().includes(search.value.toLocaleLowerCase());
      })
      .map((calculation) => {
        const client = clientsStore.getClientByUuid(calculation.client_uuid);
        const children = calculation.id !== null ? childrenByParentId.get(calculation.id) || [] : [];

        return {
          ...calculation,
          clientName: `${client?.first_name} ${client?.last_name}`,
          calculation_children: children,
        };
      });
  });

  return {
    search,
    searchedCalculations,
  };
}
